import React from 'react'

import Checkbox, {CheckboxSize} from '../../gd-components/checkbox/checkbox'
import {ItemIconClass} from "../../gd/const/item-icon/icon/item-icon-class"
import {SelectTaskTypeOption} from "./@types"

type Props = {
    options         : SelectTaskTypeOption[]
    values          : any[]
    multiselect     : boolean
    noValueLabel?   : string
    onSelect        : (option:SelectTaskTypeOption) => void
}

export default function SelectTaskTypeOptions(props:Props) {
    if (props.options.length === 0) {
        return <div className="option empty">No task types found</div>
    }

    return (
        <>
            {props.options.map(option => {

                const classes = Classes('option action', {
                    'with-icon'     : option.type !== 'no-value',
                    'no-value'      : option.type === 'no-value',
                    'multiselect'   : props.multiselect,
                    'disabled'      : option.disabled
                })

                if (option.type === 'no-value') {
                    return (
                        <div className={classes} key="no-value" onClick={()=>{props.onSelect(option)}}>
                            {/*<span className="i5-subtasks icon" />*/}
                            {props.noValueLabel}
                        </div>
                    )
                }

                const iconClass = Classes('action-icon', ItemIconClass[option.taskType.icon], {disabled: option.disabled})
                const isChecked = props.multiselect ? _.includes(props.values, option.taskType.id) : false

                return (
                    <div className={classes} key={option.taskType.id} onClick={()=>{props.onSelect(option)}}>
                        {props.multiselect && <Checkbox size={CheckboxSize.NORMAL_14} disabled={option.disabled} isChecked={isChecked}/> }
                        <div className={iconClass}></div>
                        {option.taskType.name}
                    </div>
                )
            })}
        </>
    )
}
